/*
 * Public API Surface of ng6-image-upload
 */

export * from './lib/image-upload.module';
export * from './lib/image-upload/image-upload.component';
export * from './lib/image-upload/image.service';
